export const EDIT_SUPPLIER_ORDER_ITEM_DIALOG = 'editSupplierOrderItemDialog';
